export const bankOptions = [
  { label: "CBZ Bank", value: "CBZ_BANK" },
  { label: "FBC Bank", value: "FBC_BANK" },
  { label: "CABS", value: "CABS" },
  { label: "POSB", value: "POSB" },
  { label: "ZB Bank", value: "ZB_BANK" },
  { label: "NMB Bank", value: "NMB_BANK" },
  { label: "Stanbic Bank Zimbabwe", value: "STANBIC_BANK_ZIMBABWE" },
  {
    label: "Standard Chartered Bank Zimbabwe",
    value: "STANDARD_CHARTERED_BANK_ZIMBABWE",
  },
  { label: "Ecobank Zimbabwe", value: "ECOBANK_ZIMBABWE" },
  { label: "Nedbank Zimbabwe", value: "NEDBANK_ZIMBABWE" },
  { label: "Steward Bank", value: "STEWARD_BANK" },
  { label: "Banc ABC", value: "BANC_ABC" },
  { label: "AFC Bank", value: "AFC_BANK" },
  { label: "MetBank", value: "METBANK" },
  { label: "First Capital Bank", value: "FIRST_CAPITAL_BANK" },
  {
    label: "National Building Society",
    value: "NATIONAL_BUILDING_SOCIETY",
  },
  {
    label: "Zimbabwe Women’s Microfinance Bank",
    value: "ZIMBABWE_WOMENS_MICROFINANCE_BANK",
  },
  {
    label: "Infrastructure Development Bank of Zimbabwe",
    value: "INFRASTRUCTURE_DEVELOPMENT_BANK_OF_ZIMBABWE",
  },
  { label: "Empower Bank", value: "EMPOWER_BANK" },
  {
    label: "Success Microfinance Bank",
    value: "SUCCESS_MICROFINANCE_BANK",
  },
  { label: "GetBucks Bank", value: "GETBUCKS_BANK" },
  { label: "InnBucks Bank", value: "INN_BUCKS_BANK" },
  { label: "SMEDCO Bank", value: "SMEDCO_BANK" },
  { label: "Time Bank of Zimbabwe", value: "TIME_BANK_OF_ZIMBABWE" },
  {
    label: "Tetrad Investment Bank",
    value: "TETRAD_INVESTMENT_BANK",
  },
  { label: "Lion Bank", value: "LION_BANK" },
  { label: "African Century Bank", value: "AFRICAN_CENTURY_BANK" },
  { label: "Icecash", value: "ICECASH" },
] as const;